import restTypes from '../util/rest/types';
import restStates from '../util/rest/states';
import restInitState from '../util/rest/initState';

const initialState = {};
const attributesMatrixRestTypes = restTypes('attributes_matrix');

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case attributesMatrixRestTypes.fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };
    case attributesMatrixRestTypes.fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        list: action.payload,
      };
    default: return state;
  }
};
